import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetImageUploadQueryVariables = Types.Exact<{
  mimeType: Types.Scalars['String']['input'];
  resourceId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  resourceType: Types.ImageUploadResourceTypeEnum;
}>;


export type GetImageUploadQuery = { __typename?: 'Query', imageUpload?: { __typename?: 'ImageUpload', id: string, url: string } | null };


export const GetImageUpload = /*#__PURE__*/ gql`
    query GetImageUpload($mimeType: String!, $resourceId: ID, $resourceType: ImageUploadResourceTypeEnum!) {
  imageUpload(
    mimeType: $mimeType
    resourceId: $resourceId
    resourceType: $resourceType
  ) {
    id
    url
  }
}
    ` as unknown as DocumentNode<GetImageUploadQuery, GetImageUploadQueryVariables>;

          

          export const useGetImageUploadQuery = (options?:QueryHookOptions<GetImageUploadQuery, GetImageUploadQueryVariables>) => useQuery(GetImageUpload, options);

          

          export type GetImageUploadQueryOptions = QueryHookOptions<GetImageUploadQuery, GetImageUploadQueryVariables>;

          

          export const useGetImageUploadLazyQuery = (options?:LazyQueryHookOptions<GetImageUploadQuery, GetImageUploadQueryVariables>) => useLazyQuery(GetImageUpload, options);

          

          export type GetImageUploadQueryResult = ReturnType<typeof useGetImageUploadQuery>;

          
